import axios, { type AxiosInstance, type AxiosRequestConfig, type AxiosResponse } from "axios";
import { ElMessage } from "element-plus";
import { getAuthToken, clearAuthToken } from "./util";

export class Request {
  public static axiosInstance: AxiosInstance;

  public static init() {
    const baseURL = import.meta.env.VITE_API_BASE_URL ?? "/api";
    this.axiosInstance = axios.create({
      baseURL,
      timeout: 300000
    });

    this.initInterceptors();
  }

  public static initInterceptors() {
    this.axiosInstance.defaults.headers.post["Content-Type"] = "application/json";
    this.axiosInstance.interceptors.request.use(
      (config: AxiosRequestConfig) => {
        const authorization = getAuthToken();
        if (config.headers && authorization != null) {
          config.headers.Authorization = `Bearer ${authorization}`;
        }

        return config;
      },
      (error: any) => Promise.reject(error),
    );

    this.axiosInstance.interceptors.response.use(
      (response: AxiosResponse) => {
        if (response.status !== 200) Request.errorHandle(response);
        return response;
      },
      (error: any) => {
        const { response } = error;
        if (response) {
          Request.errorHandle(response);
          return Promise.reject(response.data);
        } else {
          ElMessage.warning("网络连接异常,请稍后再试!");
        }
      }
    );
  }

  /**
   * http握手错误
   * @param res 响应回调,根据不同响应进行不同操作
   */
  private static errorHandle = (res: any) => {
    // 状态码判断
    switch (res.status) {
      case 401:
        clearAuthToken();
        window.location.href = import.meta.env.VITE_CAS_LOGIN + "/login?service=" + import.meta.env.VITE_APP_URL;
        break;
      case 403:
        break;
      case 404:
        ElMessage.warning("请求的资源不存在");
        break;
      default:
        ElMessage.warning("连接错误");
    }
  }
}
